import { Button, ButtonGroup, Dropdown, Form, DropdownItem as Item } from "react-bootstrap";
import styles from "./FilterDropdown.module.scss";
import { useTranslation } from "react-i18next";
import { ChangeEvent, useId, useState } from "react";
import { Icon } from "../../../components/icon/Icon";
import IFilterDropdownProps from "./IFilterDropdownProps";

export const FilterDropdown = (props: IFilterDropdownProps) => {
    const id = useId();
    const { t } = useTranslation();
    const { value, values, defaultLabel, onChange } = props;

    const [search, setSearch] = useState<string>("");

    const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => setSearch(e.target.value);

    return (
        <Dropdown as={ButtonGroup} size="lg" style={{ width: "100%" }}>
            
            <Button variant="primary" style={{ width: "auto" }}>
                {
                    !!value &&
                    <p className={styles.btnLabel}>
                        {defaultLabel}
                    </p>
                }

                <span className={styles.btnValue}>
                    {value || defaultLabel}
                </span>
            </Button>

            {
                !!value &&
                <Button variant="primary" onClick={() => onChange("")} className={styles.btnAction}>
                    <Icon iconName="Trash2Fill" />
                </Button>
            }

            <Dropdown.Toggle className={styles.btnAction} split variant="primary" />

            <Dropdown.Menu className={styles.menu}>
                
                <Dropdown.Header>{t("general.search")}</Dropdown.Header>
                <div className="px-3 mb-3">
                    <Form.Label htmlFor={id}>{t("general.search")}</Form.Label>
                    <Form.Control id={id} type="text" value={search} onChange={handleSearchChange} />
                </div>

                <Dropdown.Divider />

                <Dropdown.Header>{defaultLabel}</Dropdown.Header>
                {
                    values
                        .filter(v => !search || v.toLowerCase().includes(search.toLowerCase()))
                        .map((v, i) => <Item key={i} className={styles.item} onClick={() => onChange(v)}>{v}</Item>)
                }
            </Dropdown.Menu>
        </Dropdown>
    );
};